import { _ as _basePickBy } from './_basePickBy-e4f30088.js';
import { h as hasIn_1 } from './hasIn-53d8ae96.js';
import { _ as _flatRest } from './_flatRest-cb1a737b.js';
import { L as PartType, N as CheckoutEventPayloadType } from './currency-7be6806c.js';
import { _ as getBrandName } from './index-e29b327a.js';

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return hasIn_1(object, path);
  });
}

var _basePick = basePick;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

var pick_1 = pick;

class CheckoutEventEmitter {
    static prepareEventPayload(checkoutEasyPayload) {
        if (!checkoutEasyPayload)
            return null;
        return {
            payload: {
                bom: {
                    country: checkoutEasyPayload.country,
                    locale: checkoutEasyPayload.locale,
                    products: [
                        {
                            applicationSource: getBrandName(),
                            partType: PartType.NON_CTO,
                            productId: checkoutEasyPayload.productId,
                            quantity: 1,
                        },
                    ],
                },
            },
            type: CheckoutEventPayloadType.EASY,
        };
    }
    static dispatchCheckoutEvent(event, checkoutEasyPayload) {
        const eventPayload = CheckoutEventEmitter.prepareEventPayload(checkoutEasyPayload);
        if (!eventPayload) {
            console.error('[PES]: Could not trigger event. Expected non empty object.');
            return null;
        }
        const ucCtaEvent = new CustomEvent(event, {
            detail: eventPayload,
        });
        document.dispatchEvent(ucCtaEvent);
    }
}

export { CheckoutEventEmitter as C, pick_1 as p };
